import React from 'react';

import { useMessageContext } from 'stream-chat-react';
import ChatMessageView from './ChatMessageView';
import { IChatMessage } from './interfaces';
import { useChatState } from '../../../../../hooks/context';

const ChatMessage = ({ channel }: IChatMessage) => {
  const { message, isMyMessage, firstOfGroup } = useMessageContext();
  const { resolvedFailedMessageIds } = useChatState();
  const showFailedMessage =
    message.status === 'failed' &&
    !resolvedFailedMessageIds.includes(message.id);

  return (
    <ChatMessageView
      channel={channel}
      showFailedMessage={showFailedMessage}
      message={message}
      isMyMessage={isMyMessage()}
      firstMessageOfGroup={firstOfGroup}
    />
  );
};

export default ChatMessage;
